import { ShopifyListingStatus } from "@redotech/crdb-enums/product/shopify-listing-status";
import { ShopifyIdType } from "@redotech/shopify-util/id";
import { shopifyGidSchema } from "@redotech/shopify-util/id-schema";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const ShopifyCatalogStatusSchema = createEnum(ShopifyListingStatus);

export const ShopifyCatalogIdSchema = z.union([
  shopifyGidSchema(ShopifyIdType.MarketCatalog),
  shopifyGidSchema(ShopifyIdType.AppCatalog),
  shopifyGidSchema(ShopifyIdType.CompanyLocationCatalog),
]);
export type ShopifyCatalogId = z.infer<typeof ShopifyCatalogIdSchema>;

const ShopifyListingPublicationSchema_ = z.object({
  shopifyPublicationId: shopifyGidSchema(ShopifyIdType.Publication).nullable(),
  // We collapse the shopify catalog into its publication
  shopifyCatalogId: ShopifyCatalogIdSchema.nullable(),
  title: z.string(),
  status: ShopifyCatalogStatusSchema,
  publishedAt: z.date().nullable(),
  channelHandle: z.string().nullable(),
});

export const ShopifyListingPublicationSchema: z.ZodType<ShopifyListingPublication> =
  ShopifyListingPublicationSchema_;
export interface ShopifyListingPublication extends z.infer<
  typeof ShopifyListingPublicationSchema_
> {}

export type ShopifyListingPublicationWithoutRedoIds = Omit<
  ShopifyListingPublication,
  "id"
>;

export type ShopifyListingPublicationWithShopifyIds = Omit<
  ShopifyListingPublication,
  "shopifyPublicationId"
> & { shopifyPublicationId: string };
